import "./App.css";
import { BrowserRouter } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import PageRouter from "./PageRouter";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./Pages/Store";

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <PageRouter />
        <ToastContainer />
      </Provider>
    </BrowserRouter>
  );
}

export default App;
